import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-section-light pt-24 pb-16 px-6">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-[#1e3a5f] font-medium mb-8 hover:opacity-70 transition-opacity">
          <ArrowLeft className="w-4 h-4" />
          Back to home
        </Link>

        <h1 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-2 tracking-tight">Cookie Policy</h1>
        <p className="text-[#5a5a5a] text-sm mb-8">Last updated: February 2025</p>

        <div className="space-y-6 text-[#3d3d3d] text-[15px] leading-relaxed">
          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] mb-2">Our approach</h2>
            <p>This website uses only essential cookies required for basic site functionality.</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] mb-2">What we don't use</h2>
            <p>No analytics, advertising, third-party tracking, or social media cookies.</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] mb-2">Consent</h2>
            <p>Because we only use essential cookies, no consent banner is required.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
